import PermissionsMixin from './PermissionsMixin'
import PermissionsEnum from '../enums/PermissionsEnum'

export default {
  mixins: [PermissionsMixin],

  computed: {
    canEdit() {
      return this.hasPermission(PermissionsEnum.editOtherApplications)
    },

    iconsPath() {
      return this.baseUrl + '/img/icons/statuses/'
    }
  },

  methods: {
    canView(application) {
      return Boolean(
        this.user.id === application.user_id || this.hasPermission(PermissionsEnum.viewOtherApplications)
      )
    },

    canContinueEdit(application) {
      return Boolean(application.status === 'draft' && this.user && this.user.id === application.user_id)
    },

    canAttachScanCopy(application) {
      return Boolean(
        Number(application.user_id) === Number(this.user.id) &&
        application.status === 'awaiting_signing' &&
        Number(this.configuration.can_attach_scancopy) === 1
      )
    },

    canDuplicate(application) {
      return Boolean(
        application.status !== 'draft' && (
          this.user.id === application.user_id || this.hasPermission(PermissionsEnum.duplicateOtherApplications)
        )
      )
    },

    canDelete(application) {
      return Boolean(application.status === 'draft' && this.user && this.user.id === application.user_id)
    },

    canPrint(application) {
      return Boolean(this.hasPermission(PermissionsEnum.printApplicationPrintedForm) && this.user && application.status !== 'draft')
    },

    deleteApplication(application) {
      if (confirm('Удалить заявку? Она покинет нас навсегда')) {
        window.location.href = String(this.baseUrl + 'profile/delete?' +
            'id=' + application.id + '&archived=' + this.archived +
            '&page=' + this.pagination.active + '&filter=' + this.searchStatus +
            '&typeFilter=' + this.typeFilter + '&subdivFilter=' + this.subdivFilter +
            '&pageCount=' + Number(this.pagination.count)
        )
      }
    },

    canSeeUsersInLogs(application) {
      return Boolean(this.user && this.hasPermission(PermissionsEnum.canSeeUsersInLogs))
    }
  }
}
